export const ASCENDING = 'ASCENDING';
export const DESCENDING = 'DESCENDING';

export type SortDirection = typeof ASCENDING | typeof DESCENDING;

export interface SortCriteria<T> {
  compareFn: (a: T, b: T) => number;
  direction: SortDirection;
}

export interface SortData<T> extends SortCriteria<T> {
  key: string;
}

export interface TreeDataNode<T> {
  title: string;
  shortTitle: string;
  value: string;
  sortBy: SortCriteria<T>;
  key: string;
  selectable: boolean;
  checkable?: boolean;
  children?: TreeDataNode<T>[];
  sectionPairNumber?: number;
}

export interface TreeSelectSortInputProps<T> {
  handleSetSort: (values: SortData<T>[]) => void;
  handleResetSort: () => void;
  treeData: TreeDataNode<T>[];
  initSort: string[];
}
